import * as React from "react";

const Backdrop = ({ containerClass, handleCloseBackdrop, toolTipContainerClass, onClickBackdrop, toolTipInfo, okBtnText }) => {
    return (<div className={containerClass}>
        <div className="backdrop" />
        <div className="backdrop-tool-tip-container">
            <p>{toolTipInfo}</p>
            <button aria-label="GotIt" className="btn text-btn" onClick={handleCloseBackdrop}>{okBtnText}</button>
            <div className="backdrop-tool-tip-arrow" />
        </div>
    </div>);
};

export default Backdrop;